import Question, { QuestionsContainer, QuestionWrapper } from 'components/reports/Question'
import OutputDetails from 'components/reports/OutputDetails'
import ReferrableQuestionWrapper from 'components/reports/ReferrableQuestionWrapper'
import { formatDateMonthYear } from 'hooks/useDateUtils'

export default function MusculoskeletalDetails({ data }) {

    var questions = data.conditionSpecific.questions

    return (
        <>
            <h3>Musculoskeletal Questions</h3>

            <QuestionsContainer>

                <QuestionWrapper number='1'>
                    <Question>Please provide the exact diagnosis of this condition:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.exactDiagnosis.referToAttachments}>
                        <p>{questions.exactDiagnosis.value}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='2'>
                    <Question>Please confirm the date of diagnosis and presenting symptoms:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.diagnosisDetails.referToAttachments}>
                        <br />
                        <Question>Date of Diagnosis:</Question>
                        <p>{formatDateMonthYear(questions.diagnosisDetails.subQuestions.dateOfDiagnosis)}</p>

                        <Question>Presenting symptoms:</Question>
                        <p>{questions.diagnosisDetails.subQuestions.presentingSymptoms}</p>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='3'>
                    <Question>Please provide details of your patient’s symptoms in the last 5 years to include:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.symptoms.referToAttachments}>
                        <QuestionsContainer>
                            <br />
                            <QuestionWrapper number='a'>
                                <Question>Nature of Symptoms</Question>
                                <p>{questions.symptoms.subQuestions.natureOf}</p>
                            </QuestionWrapper>

                            <QuestionWrapper number='b'>
                                <Question>Severity of Symptoms:</Question>
                                <p>{questions.symptoms.subQuestions.severity}</p>
                            </QuestionWrapper>

                            <QuestionWrapper number='c'>
                                <Question>Frequency of Symptoms:</Question>
                                <p>{questions.symptoms.subQuestions.frequency}</p>
                            </QuestionWrapper>

                            <QuestionWrapper number='d'>
                                <Question>Date of Most Recent Symptoms:</Question>
                                <p>{formatDateMonthYear(questions.symptoms.subQuestions.dateOfLastSymptoms)}</p>
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='4'>
                    <Question>Please provide details of any treatment in the last 5 years:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.treatmentProvided.referToAttachments}>
                        <QuestionsContainer>
                            <QuestionWrapper number='a'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.surgery ? 'Yes' : 'No'}
                                >
                                    Surgery:
                                </Question>

                                {questions.treatmentProvided.subQuestions.surgery === true && (
                                    <>
                                        <br />
                                        <Question>If yes, please provide the following details including type of surgery and date completed:</Question>
                                        <OutputDetails
                                            details={questions.treatmentProvided.subQuestions.surgeryDetails}
                                        />
                                    </>
                                )}
                            </QuestionWrapper>

                            <QuestionWrapper number='b'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.medication ? 'Yes' : 'No'}
                                >
                                    Medication:
                                </Question>

                                {questions.treatmentProvided.subQuestions.medication === true && (
                                    <>
                                        <br />
                                        <>
                                            <Question>If yes, please provide medication details:</Question>
                                            <p>{questions.treatmentProvided.subQuestions.medicationDetails}</p>
                                        </>
                                    </>
                                )}
                            </QuestionWrapper>

                            <QuestionWrapper number='c'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.physiotherapy ? 'Yes' : 'No'}
                                >
                                    Physiotherapy:
                                </Question>
                            </QuestionWrapper>

                            <QuestionWrapper number='d'>
                                <Question
                                    answer={questions.treatmentProvided.subQuestions.other ? 'Yes' : 'No'}
                                >
                                    Other:
                                </Question>

                                {questions.treatmentProvided.subQuestions.other === true && (
                                    <>
                                        <br />
                                        <>
                                            <Question>If yes, please provide other details:</Question>
                                            <p>{questions.treatmentProvided.subQuestions.otherDetails}</p>
                                        </>
                                    </>
                                )}
                            </QuestionWrapper>
                        </QuestionsContainer>
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='5'>
                    <Question>Please provide the date and results of any investigations e.g.  Xray, MRI etc:</Question>
                    <ReferrableQuestionWrapper isReferred={questions.investigations.referToAttachments}>
                        <OutputDetails
                            details={questions.investigations.details}
                        />
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='6'>
                    <Question>Was the patient off work for any length of time in the last 5 years?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyTimeOffWorkCaused.referToAttachments}>
                        <p>{questions.anyTimeOffWorkCaused.value}</p>
                        {questions.anyTimeOffWorkCaused.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details of any time off work in the last 5 years to include dates and duration:</Question>
                                <OutputDetails
                                    details={questions.anyTimeOffWorkCaused.details}
                                />
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

                <QuestionWrapper number='7'>
                    <Question>Are there any other factors or co-morbidities present which may influence the prognosis of this condition?</Question>
                    <ReferrableQuestionWrapper isReferred={questions.anyOtherFactors.referToAttachments}>
                        <p>{questions.anyOtherFactors.value}</p>
                        {questions.anyOtherFactors.value === 'Yes' && (
                            <>
                                <Question>If yes, please provide details:</Question>
                                <p>{questions.anyOtherFactors.details}</p>
                            </>
                        )}
                    </ReferrableQuestionWrapper>
                </QuestionWrapper>

            </QuestionsContainer>
        </>
    )
}